/**
 * @file scripts/pages/home.jsx
 * @description
 * This is our home page, a public-facing portal with some marketing text for
 * prospects and handy jump-links for existing users.
 */
import React, {Component} from 'react';
import history from '../utils/history';
import FinchButton from '../components/demo/FinchButton';
import session from '../utils/session';
import urlHandler from '../utils/urlHandler';
import permissions from '../utils/permissions';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            warning: 'true',
            kbPermission: false
        }

        this.disambiguationPage = this.disambiguationPage.bind(this);
        this.documentationPage = this.documentationPage.bind(this);
        this.knowledgebasePage = this.knowledgebasePage.bind(this);
    }

    componentDidMount() {
        var search = permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntitySearch']);
        var read = permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityRead']);
        if (search || read) {
            this.setState({
                kbPermission: true
            })           
        }        
    }

    componentDidUpdate() {
        var search = permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntitySearch']);
        var read = permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENTITIES, ['EntityRead']);
        if ((search || read) && !this.state.kbPermission) {
            this.setState({
                kbPermission: true
            })           
        }        
    }

    disambiguationPage() {
        if (session.isAuthenticated()) {
            history.push('demo');
        } else {
            history.push('login');   
        }
        
    }

    documentationPage(){
        history.push('documentation/doc_overview#top');
    }

    knowledgebasePage() {
        if (session.isAuthenticated()) {
            history.push('knowledgebase');
        } else {
            history.push('login');   
        }
        
    }

    render(){
        return (
            <div className="home-wrapper">
                <div className="banner">
                    <div className="marquee">
                        <div className="title">
                            Software that reads and reasons.
                        </div>
                        <div className="description">
                            Fast and accurate insights from streaming or static text. Disambiguate identically 
                            named <b>people</b>, <b>places</b> and <b>organizations</b>.
                        </div>
                    </div>
                </div>
                <div className="features">
                    <div className="feature">
                        <div className="title">Try It Now!</div>
                        <div className="content">
                            Quickly and accurately identify more than 20 unique entity types. Paste your own text - or use one of our
                            samples - and get instant results.
                        </div>
                        <div className="action">
                            <FinchButton
                                warning = {true}
                                primary={true}
                                text = "Demo"
                                submit = {this.disambiguationPage}>
                            </FinchButton> 
                        </div>
                    </div>
                    {this.state.kbPermission &&
                        <div className="feature">
                            <div className="title">Finch Knowledgebase</div>
                            <div className="content">
                                Explore and Update the entities in the Finch Knowledgebase.
                            </div>
                            <div className="action">
                                <FinchButton
                                    warning = {true}
                                    primary={true}
                                    text = "Knowledgebase"
                                    submit = {this.knowledgebasePage}>
                                </FinchButton> 
                            </div>
                        </div>
                    }
                    <div className="feature">
                        <div className="title">Simple, Powerful API</div>
                        <div className="content">
                            Access the documentation and resources you need to uncover new insights into your data, at scale.
                        </div>
                        <div className="action">
                            <FinchButton
                                warning = {true}
                                primary={true}
                                text = "Documentation"
                                submit = {this.documentationPage}>
                            </FinchButton> 
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="logo"></div>
                    <div className="contacts">
                        <div className="contact">
                            <div className="location">Washington, DC</div>
                            <div className="address">
                                11911 Freedom Drive<br/>
                                Suite 900<br/>
                                Reston, VA  20190
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
